import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { CareerPath, Industry } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { TheScoop } from '@backrs_ui/grow-ui/src/components/ResourceWrapper/TheScoop';
import { ScoopStatItem } from '@backrs_ui/grow-ui/src/components/ResourceWrapper/types';
import { WhatIsACareerPathModal } from '@backrs_ui/grow-ui/src/pages/CareerPath/molecules/careerPathPage/WhatIsACareerPathModal';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

const STRINGS = appStrings.modules.internship;

type QualificationsPanelProps = Readonly<{
  requirements?: string;
  industry?: Industry;
  industryName?: string;
  careerPaths?: CareerPath[];
}>;

export const QualificationsPanel = ({
  requirements,
  industry,
  industryName,
  careerPaths = [],
}: QualificationsPanelProps) => {
  const navigate = useNavigate();
  const [isCareerPathModalOpen, setIsCareerPathModalOpen] = useState(false);

  const allCareerPaths = useAppSelector((state) => state.careerPath.careerPaths);
  const allCareerCategories = useAppSelector((state) => state.careerPath.careerCategories);

  const summaryItems = requirements
    ? [{ title: STRINGS.qualifications.requirementsHeading, description: requirements }]
    : [];

  const resolvedIndustryName = industry?.name ?? industryName;

  const statItems: ScoopStatItem[] = [
    industry &&
      resolvedIndustryName && {
        kind: 'pills' as const,
        title: STRINGS.scoop.industry,
        pills: [
          {
            id: `internship-industry-${industry.id}-chip`,
            label: resolvedIndustryName,
            onClick: () => navigate(`${APP_ROUTE.INDUSTRIES}/${industry.id}`),
          },
        ],
      },
    careerPaths.length > 0 && {
      kind: 'pills' as const,
      title: STRINGS.scoop.careerPath,
      pills: careerPaths.map((careerPath) => ({
        id: `internship-career-path-${careerPath.id}-chip`,
        label: careerPath.name,
        onClick: () => navigate(`${APP_ROUTE.CAREER_PATHS}/${careerPath.id}`),
      })),
      info: { kind: 'click', onClick: () => setIsCareerPathModalOpen(true) },
    },
  ].filter(Boolean) as ScoopStatItem[];

  return (
    <>
      <TheScoop summaryItems={summaryItems} statItems={statItems} />
      <WhatIsACareerPathModal
        open={isCareerPathModalOpen}
        onClose={() => setIsCareerPathModalOpen(false)}
        careerPaths={allCareerPaths}
        careerCategories={allCareerCategories}
      />
    </>
  );
};
